module.exports = __webpack_public_path__ + "img/icon-hospital.d6220bd8.png";